/**
 * «Голосовой ввод текста на компьютере» — бесплатная часть Конспекта своей
 * посадочной в разделе «Программы» (04.10.2026).
 *
 * Тексты — по ТЗ Seo-marketing (`SEO-Marketing/diktovka-seo.md`) с правками
 * по Вордстату: «голосовой набор текста» (1 256 в месяц с компьютера, отдельный
 * хвост) и «голосовой ввод в ворде». Слова «диктовка» на русской странице нет
 * нарочно: в Яндексе это школьные диктанты, не наш спрос.
 *
 * Отдельная программа, а не подстраница Конспекта: человек ищет «программу
 * для голосового ввода», а не функцию программы для встреч.
 *
 * Все обещания сверены с кодом Конспекта 04.10 (`app/dictation/`, строки
 * интерфейса `web/i18n/ru.json`), языки — по выпуску 0.15.1 (03.10.2026; немецкий с 0.15.2 — 10 % ошибок в словах при немецкой Windows или раскладке; сербский с 0.15.3 своей моделью — 16 % (290 МБ, качается только при сербском)): бесплатно и не тратит пробные встречи,
 * предел 300 секунд, полоска «слушаю», четыре сочетания клавиш, два режима,
 * окна администратора — текст остаётся в буфере. Не обещаем: скорость,
 * голосовые команды, игры и удалённый стол, macOS, работу во время записи.
 */

/** Путь страницы внутри витрины. */
export const PUT_GOLOSOVOGO_VVODA = '/programmy/golosovoy-vvod';

export const TEKST_GOLOSOVOGO_VVODA = {
  title: 'Голосовой ввод текста на компьютере — бесплатно, без интернета',
  description:
    'Бесплатная программа для голосового ввода на Windows: зажмите клавиши, скажите — текст появится в Word, браузере или мессенджере. Работает без интернета.',
  nadzagolovok: 'Программа для Windows',
  h1: 'Голосовой ввод текста на компьютере: бесплатно и без интернета',
  podzagolovok: 'Голосовой набор текста бесплатно — в Ворде и любой программе Windows 10 и 11',
  lead: 'Зажмите Ctrl+Shift+D, скажите фразу и отпустите — текст появится там, где стоит курсор: в Word, браузере, Telegram, почте. Распознавание идёт на вашем компьютере, звук никуда не отправляется. Голосовой ввод входит в программу Конспект и бесплатен.',
  podKnopkoj: 'Windows 10 и 11 · бесплатно · без регистрации',
  /** Карточка в разделе «Программы». */
  korotko:
    'Бесплатный голосовой набор текста в Word, браузере и мессенджерах: зажали клавиши, сказали, отпустили. Работает без интернета.',
};

export const KAK_RABOTAET_SHAGI = [
  'Установите Конспект и при первом запуске дождитесь загрузки модели распознавания.',
  'Поставьте курсор туда, где нужен текст.',
  'Зажмите Ctrl+Shift+D и говорите. Пока вы говорите, на экране видна полоска «слушаю».',
  'Отпустите клавиши — текст вставится целиком, с запятыми, точками и заглавными буквами.',
];

export interface RazdelTeksta {
  zagolovok: string;
  abzacy: string[];
  punkty?: string[];
}

export const RAZDELY_GOLOSOVOGO_VVODA: RazdelTeksta[] = [
  {
    zagolovok: 'Где работает',
    abzacy: [
      'Голосовой ввод в Ворде, браузере и мессенджерах — и в любом другом приложении Windows, где можно печатать: Word и Google Документы, Telegram и WhatsApp для компьютера, почта, заметки, 1С. За один раз можно наговорить до пяти минут.',
      'Исключение — окна, запущенные от имени администратора: Windows не пускает в них ввод ни от одной программы. В этом случае текст останется в буфере обмена, вставьте его Ctrl+V.',
    ],
  },
  {
    zagolovok: 'Почему без интернета — это важно',
    abzacy: [
      'Конспект распознаёт речь на вашем компьютере: звук и текст никуда не отправляются. Можно надиктовать письмо, договор или заметку с личными данными и не думать, куда они уходят.',
      'И это работает там, где сети нет или она закрыта: в поезде, на даче, в офисе с ограниченным интернетом. Интернет нужен один раз — скачать модель распознавания.',
    ],
  },
  {
    zagolovok: 'Чем отличается от голосового ввода Windows и Word',
    abzacy: [],
    punkty: [
      'Работает без интернета после загрузки модели.',
      'Один и тот же способ в любом приложении, а не только в Word.',
      'Русскую речь распознаёт модель GigaAM, сделанная для русского языка.',
      'Знаки препинания и заглавные буквы ставятся сами.',
    ],
  },
  {
    zagolovok: 'Настройки',
    abzacy: [],
    punkty: [
      'Сочетание клавиш: Ctrl+Shift+D, Ctrl+Shift+Пробел, Ctrl+Alt+D или Alt+Q.',
      'Режим: держать клавиши, пока говорите, или нажать один раз, чтобы начать, и ещё раз, чтобы закончить. Второй удобнее для длинного текста.',
      'Вставка: через буфер обмена (мгновенно, прежнее содержимое буфера возвращается на место) или печатью по буквам.',
      'Можно пользоваться только голосовым вводом, без записи встреч: в настройках программы включите «Диктовать в любое приложение». Окно Конспекта открывать не нужно, программа работает из трея.',
    ],
  },
];

/** Блок о платной части: та же программа записывает встречи. */
export const PRO_KONSPEKT = {
  zagolovok: 'А ещё Конспект записывает встречи',
  tekst:
    'Та же программа записывает созвоны в Zoom, Телемосте и любом другом приложении, расшифровывает их и пишет итоги. Это платная часть, первые 10 встреч — бесплатно. Голосовой ввод остаётся бесплатным в любом случае.',
  ssylka: 'Подробнее о Конспекте',
};

export const TREBOVANIYA_GOLOSOVOGO_VVODA =
  'Windows 10 или 11, 64 бита. Модель распознавания русского — около 220 МБ, скачивается один раз. Видеокарта не нужна. Для других языков программа сама докачает ещё около 360 МБ, для сербского — ещё около 290 МБ.';

export function voprosyGolosovogoVvoda(): { vopros: string; otvet: string }[] {
  return [
    {
      vopros: 'Голосовой ввод правда бесплатный?',
      otvet: 'Да. Он не требует лицензии и регистрации и не тратит пробные встречи Конспекта.',
    },
    {
      vopros: 'Как включить голосовой ввод в Ворде?',
      otvet:
        'Установите Конспект, поставьте курсор в документ Word, зажмите Ctrl+Shift+D и говорите. Встроенный ввод Word для этого не нужен.',
    },
    {
      vopros: 'Нужен ли интернет?',
      otvet: 'Только один раз, чтобы скачать модель. Потом голосовой ввод работает без сети.',
    },
    {
      vopros: 'Расставляет ли знаки препинания?',
      otvet:
        'Да, запятые, точки и заглавные буквы ставятся сами. Голосовых команд вроде «новая строка» пока нет.',
    },
    {
      vopros: 'Работает ли в Word?',
      otvet: 'Да, и в любом другом приложении Windows, где можно печатать.',
    },
    {
      vopros: 'Какие языки?',
      otvet:
        'Русский, английский и испанский — язык каждой фразы определяется сам. Немецкий и сербский — если они есть в языках Windows или выбраны основным языком встреч. Другие языки тоже работают, но точность у них ниже.',
    },
    {
      vopros: 'Есть ли версия для Mac или телефона?',
      otvet: 'Нет, только Windows 10 и 11.',
    },
    {
      vopros: 'Почему текст появляется не сразу, а после того, как я отпустил клавиши?',
      otvet:
        'Так программа распознаёт фразу целиком и расставляет знаки препинания. Это не набор по буквам на лету.',
    },
  ];
}
